<div class="card card-danger">
  <div class="card-header">
    <div class="float-left"><h5> Clients </h5></div>
    <div class="float-right">
      <div class="btn-group" role="group" aria-label="Basic example">
        <button (click)="showFind()" type="button" class="btn btn-sm btn-outline-info"><i class="fa fa-search" aria-hidden="true"></i> Find</button>
        <button (click)="showNew()" type="button" class="btn btn-sm btn-outline-success"><i class="fa fa-plus" aria-hidden="true"></i> Add new </button>
      </div>
    </div>
  </div>

  <div class="card-body">
    <div class="row">
      <div class="col">

        <div *ngIf="mode==formModes.Find">
          <div class="row" style="margin-left: 0px;">
            <div class="col-sm-6">
              <div class="form-group row">
                <label for="Name" class="col-sm-3 col-form-label" style="position: relative; top: 6px;">Name</label>
                <div class="col-sm-9" style="margin-left: -64px; height: 0px;">
                  <!-- <input [(ngModel)]="clientName" maxlength="50" class="form-control form-control-sm" #name="ngModel" type="text" id="Name" name="Name"/> -->
                  <mat-form-field appearance="outline">
                    <mat-label>Name</mat-label>
                    <input matInput [(ngModel)]="clientName" maxlength="50" #name="ngModel" type="text" id="Name" name="Name" />
                  </mat-form-field>
                </div>
              </div>
            </div>
            <div class="col-sm-6">
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12" style="position: relative; top: 16px;">
              <div class="text-center m-3">
                <button type="button" (click)="onSubmit()" class="btn btn-sm btn-info mx-1"><i class="fa fa-search" aria-hidden="true"></i> Search </button>
                <button type="button" class="btn btn-sm btn-outline-secondary mx-1" style="color: white; background-color: #2f72ab;" (click)="resetForm()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel </button>
              </div>
              <br />
            </div>
          </div>
        </div>

        <div *ngIf="mode==formModes.New || mode==formModes.Edit" style="margin-left: 80px;">
          <form #f="ngForm" (ngSubmit)="onSubmit(f)">
            <div class="row" style="margin-right: -41px">
              <div class="col-sm-6">


                <div class="form-group row">
                  <label for="carrierSymbol" class="col-sm-3 col-form-label">Parent</label>
                  <div class="col-sm-9">
                    <!-- <p-dropdown [filter]="true" filterBy="label" [options]="Carriers" [(ngModel)]="Carrier" optionLabel="name" id="CarrierOption" name="CarrierOption" required #CarrierOption="ngModel" placeholder="Select carrier" [showClear]="true"></p-dropdown> -->
                    <mat-form-field appearance="outline">
                      <mat-label>Select Parent</mat-label>
                      <mat-select [(ngModel)]="model.clientMasterId" id="ClientMasterOption" name="ClientMasterOption" #ClientMasterOption="ngModel">
                        <mat-option *ngFor="let master of clientMasters" [value]="master.id">
                          {{master.name}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                    <div *ngIf="ClientMasterOption.invalid && (ClientMasterOption.dirty || ClientMasterOption.touched)" class="text-danger small">
                      <div *ngIf="ClientMasterOption.errors.required">
                        Client needs to be selected.
                      </div>
                    </div>
                  </div>
                </div>

                <div class="form-group row">
                  <label for="Name" class="col-sm-3 col-form-label">Name</label>
                  <div class="col-sm-9">
                    <mat-form-field appearance="outline">
                      <mat-label>Enter client/location name</mat-label>
                      <input matInput [(ngModel)]="model.name" required maxlength="50" #name="ngModel" type="text" id="Name" name="Name">
                    </mat-form-field>
                    <div *ngIf="name.invalid && (name.dirty && name.touched)" class="text-danger small">
                      <div *ngIf="name.errors.required">
                        Name is required.
                      </div>
                      <div *ngIf="name.errors.maxlength">
                        Name must be less than 50 characters long.
                      </div>
                    </div>
                  </div>
                </div>

                <div class="form-group row">
                  <label for="APIKey" class="col-sm-3 col-form-label">Client API Key</label>
                  <div class="col-sm-9">
                    <mat-form-field appearance="outline">
                      <mat-label>API Key</mat-label>
                      <input matInput [(ngModel)]="model.apiKey" disabled maxlength="50" #apiKey="ngModel" type="text" id="apiKey" name="apiKey">
                    </mat-form-field>
                  </div>
                </div>



              </div>
            </div>
            <div class="row">
              <div class="col-sm-12">
                <div class="text-center m-3">
                  <!--<button type="button" (click)="showMappingsModal()" *ngIf="this.isRateFileButtonDisplay == true" class="btn btn-sm btn-info mx-1"> <i class="fa fa-file-excel-o" aria-hidden="true"></i> Map Carrier Rate Files</button>-->
                  <button type="submit" [disabled]="f.invalid" *ngIf="mode==formModes.New" class="btn btn-sm btn-success mx-1"><i class="fa fa-plus" aria-hidden="true"></i> Save </button>
                  <button type="submit" [disabled]="f.invalid" *ngIf="mode==formModes.Edit" class="btn btn-sm mx-1" style="color: white; background-color: #2f72ab;"><i class="fa fa-floppy-o" aria-hidden="true"></i> Update </button>
                  <button type="button" class="btn btn-sm btn-outline-secondary mx-1" style="color: white; background-color: #2f72ab;" (click)="resetForm()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel </button>
                </div>
                <br />
              </div>
            </div>
          </form>
          <div class="row" *ngIf="mode==formModes.Edit">

            <!-- Carriers -->
            <div class="row" id="carriersGrid" style="margin-top: 5vh">
              <h2>Carriers</h2>
              <div class="row">
                <div class="col-sm-12">

                  <div [formGroup]="carriersForm">
                    <ng-container formArrayName="clientCarriers" class="row">
                      <ng-container *ngFor="let element of clientCarriers.controls; let i = index">
                        <div formGroupName="{{i}}">
                          <div class="row">
                            <div class="col-sm-3">
                              <div class="row">
                                <mat-form-field appearance="outline">
                                  <mat-label>Account     </mat-label>
                                  <mat-select formControlName="carrierId" name="carrierId">
                                    <mat-option [value]="null">None</mat-option>
                                    <mat-option *ngFor="let carrier of availableCarriers" [value]="carrier.id">
                                      {{carrier.name}} {{carrier.accountNumber?.length > 0 ? "- " + carrier.accountNumber : ""}}
                                    </mat-option>
                                  </mat-select>
                                </mat-form-field>
                              </div>
                            </div>
                            <div class="col-sm-2" style="display:inline-flex">
                              <mat-checkbox formControlName="immediatePayments">No invoice import?</mat-checkbox>
                            </div>
                            <!--<div class="col-sm-2" style="display:inline-flex">
      <mat-checkbox formControlName="noMarkups">No markups?</mat-checkbox>
    </div>-->
                            <div class="col-sm-2" style="display:inline-flex">
                              <mat-checkbox formControlName="bypassRateValidation">No cost validation?</mat-checkbox>
                            </div>
                            <div class="col-sm-1" style="display:inline-flex">
                              <mat-form-field appearance="outline">
                                <mat-label>Txn Fee</mat-label>
                                <input type="number" matInput formControlName="transactionFee" />
                              </mat-form-field>
                            </div>
                            <div class="col-sm-1" style="display:inline-flex">
                              <mat-form-field appearance="outline" style="width:110px">
                                <mat-label>Txn Pct</mat-label>
                                <input type="number" matInput formControlName="transactionFeePercentage" />
                              </mat-form-field>
                            </div>
                            <div class="col-sm-2" style="display:inline-flex">

                              <div style="display: inline-flex;height:45px">
                                <button type="button" (click)="removeCarrier(i)" class="btn btn-danger mx-1">
                                  <i class="fa fa-trash" aria-hidden="true"></i>
                                  Remove
                                </button>
                                <button type="button" (click)="saveCarrier(element)" class="btn btn-info mx-1">
                                  <i class="fa fa-save" aria-hidden="true"></i>
                                  Save
                                </button>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-sm-3">
                              <ng-container *ngIf="element.isMultiCarrier">
                                <mat-form-field appearance="outline">
                                  <mat-label>Carrier     </mat-label>
                                  <mat-select formControlName="childCarrier" name="childCarrier">
                                    <mat-option [value]="null">None</mat-option>
                                    <mat-option *ngFor="let carrier of childCarriers" [value]="carrier.value">
                                      {{carrier.label}}
                                    </mat-option>
                                  </mat-select>
                                </mat-form-field>
                              </ng-container>
                              <ng-container *ngIf="hasChildAccounts(element.controls.carrierId.value)">
                                <mat-form-field appearance="outline">
                                  <mat-label>Child Account     </mat-label>
                                  <mat-select formControlName="childAccountId" name="childAccountId">
                                    <mat-option [value]="null">None</mat-option>
                                    <mat-option *ngFor="let carrier of getChildAccounts(element.controls.carrierId.value)" [value]="carrier.id">
                                      {{carrier.name}} - {{carrier.accountNumber}}
                                    </mat-option>
                                  </mat-select>
                                </mat-form-field>
                              </ng-container>
                            </div>
                          </div>
                        </div>
                      </ng-container>

                    </ng-container>

                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-sm-2">
                  <button type="button" (click)="addCarrier()" class="btn btn-info mx-1"> + Add Carrier</button>
                </div>
              </div>
            </div>


            <!-- Rate Files -->
            <div class="row" id="rateFilesGrid" style="margin-top: 5vh">
              <h2>Rate Files</h2>
              <div class="row">
                <div class="col-sm-8">

                  <div [formGroup]="rateFilesForm">
                    <ng-container formArrayName="rateFiles" class="row">
                      <ng-container *ngFor="let rateFileForm of rateFiles.controls; let i = index">
                        <div formGroupName="{{i}}">
                          <mat-form-field appearance="outline">
                            <mat-label>Carrier     </mat-label>
                            <mat-select formControlName="carrierCode">
                              <mat-option [value]="null">None</mat-option>
                              <mat-option *ngFor="let carrier of carriers" [value]="carrier.value">
                                {{carrier.label}}
                              </mat-option>
                            </mat-select>
                          </mat-form-field>
                          <mat-form-field appearance="outline" class="col-md-5">
                            <mat-label>Rate File     </mat-label>
                            <mat-select formControlName="carrierRateFileId">
                              <mat-option [value]="null">None</mat-option>
                              <mat-option *ngFor="let ratefile of getRateFilesForCarrier(rateFileForm)" [value]="ratefile.value.id">
                                {{ratefile.label}} (uploaded on {{ratefile.value.uploadedOn}})
                              </mat-option>
                            </mat-select>
                          </mat-form-field>

                          <div class="col-sm-4" style="display: inline-flex;height:45px">
                            <button type="button" (click)="removeRateFile(i)" class="btn btn-danger mx-1">
                              <i class="fa fa-trash" aria-hidden="true"></i>
                              Remove
                            </button>
                            <button type="button" (click)="saveRateFile(rateFileForm)" class="btn btn-info mx-1">
                              <i class="fa fa-save" aria-hidden="true"></i>
                              Save
                            </button>
                          </div>
                        </div>
                      </ng-container>

                    </ng-container>

                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-3">
                  <button type="button" (click)="addRateFile()" class="btn btn-info mx-1"> + Add Rate File</button>
                </div>
              </div>

            </div>


            <!-- Rating Profiles -->
            <div class="row" id="ratingProfilesGrid" style="margin-top: 5vh">
              <h2>Rate Profiles</h2>
              <div class="row">
                <div class="col-sm-8">


                  <div [formGroup]="ratingProfilesForm">
                    <ng-container formArrayName="ratingProfiles" class="row">
                      <ng-container *ngFor="let ratingProfileForm of ratingProfiles.controls; let i = index">
                        <div formGroupName="{{i}}">
                          <mat-form-field appearance="outline">
                            <mat-label>Rating Profile     </mat-label>
                            <mat-select formControlName="ratingProfileId" name="ratingProfileId">
                              <mat-option *ngFor="let profile of availableRatingProfiles" [value]="profile.id">
                                {{profile.profileName}}
                              </mat-option>
                            </mat-select>
                          </mat-form-field>

                          <div class="col-sm-4" style="display: inline-flex;height:45px">
                            <button type="button" (click)="removeRatingProfile(i)" class="btn btn-danger mx-1">
                              <i class="fa fa-trash" aria-hidden="true"></i>
                              Remove
                            </button>
                            <button type="button" (click)="saveRatingProfile(ratingProfileForm)" class="btn btn-info mx-1">
                              <i class="fa fa-save" aria-hidden="true"></i>
                              Save
                            </button>
                          </div>
                        </div>
                      </ng-container>

                    </ng-container>

                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-6">
                  <button type="button" (click)="addRatingProfile()" class="btn btn-info mx-1"> + Add Rating Profile</button>
                </div>
              </div>

            </div>

          </div>
        </div>

        <div *ngIf="mode==formModes.Del">
          <div class="row">
            <div class="col-sm-6">
              <div class="form-group row">
                <label for="Name" class="col-sm-3 col-form-label">Name</label>
                <div class="col-sm-9">
                  <mat-form-field appearance="outline">
                    <mat-label>Enter your name</mat-label>
                    <input matInput [(ngModel)]="model.name" required maxlength="50" #name="ngModel" type="text" id="Name" name="Name" [readonly]="true">
                  </mat-form-field>
                  <div *ngIf="name.invalid && (name.dirty && name.touched)" class="text-danger small">
                    <div *ngIf="name.errors.required">
                      Name is required.
                    </div>
                    <div *ngIf="name.errors.maxlength">
                      Name must be less than 50 characters long.
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <div class="text-center m-3">
                <button type="button" (click)="onSubmit()" class="btn btn-sm btn-danger mx-1"><i class="fa fa-times" aria-hidden="true"></i> Delete </button>
                <button type="button" (click)="resetForm()" style="color: white; background-color: #2f72ab;" class="btn btn-sm mx-1"><i class="fa fa-ban" aria-hidden="true"></i> Cancel </button>
              </div>
              <br />
            </div>
          </div>
        </div>

      </div>
    </div>

    <div *ngIf="mode != formModes.New && mode != formModes.Edit" class="row">
      <div class="col">

        <div class="mat-elevation-z8">
          <table mat-table [dataSource]="ClientdataSource">

            <!-- <ng-container matColumnDef="Id">
    <th mat-header-cell *matHeaderCellDef mat-sort-header> Id </th>
    <td mat-cell *matCellDef="let row">{{ row.id }}  </td>
  </ng-container> -->

            <ng-container matColumnDef="Name">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> Name </th>
              <td mat-cell *matCellDef="let row"> {{ row.name }} </td>
            </ng-container>
            <ng-container matColumnDef="APIKey">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> API Key </th>
              <td mat-cell *matCellDef="let row"> {{ row.apiKey }} </td>
            </ng-container>
            <ng-container matColumnDef="Actions">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> Actions </th>
              <td mat-cell *matCellDef="let row">
                <button (click)="showEdit(row)" class="btn btn-sm btn-outline-primary"><i class="fa fa-pencil" aria-hidden="true"></i></button>
                <button (click)="delete(row)" class="btn btn-sm btn-outline-danger"><i class="fa fa-times" aria-hidden="true"></i></button>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>


          </table>
          <!--<tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" colspan="4">There is no record</td>
      </tr>-->
          <span style="position: relative; left: 40%; font-size: 13px; top: 40px;">There are {{this.tabledata?.length}} records</span>
          <mat-paginator [length]="this.tabledata?.length" [pageSizeOptions]="[10 ,50, 100]" aria-label="Select page of users" (page)="onChangedPageSize($event)"></mat-paginator>
        </div>
      </div>
    </div>
  </div>
</div>


<!--<div>-->
  <!-- <button mat-raised-button (click)="showMappingsModal()">Pick one</button> -->
<!--</div>
<ng-template #callAPIDialog>
  <div style=" width: 95%; margin-right: 22px; margin-left: 22px; max-height: 500px;">
    <mat-dialog-content style="display: flex; justify-content: end; margin-right: -42px;">
      <button mat-icon-button mat-dialog-close class="close-icon" (click)="close()" style=" margin-right: 28px;">
        <mat-icon style="margin-right: -30px; font-size: 20px;">close</mat-icon>
      </button>
    </mat-dialog-content>
    <div style="display : flex">
      <form #CarrierForm="ngForm">
        <div style="display: flex; position: relative; top: -40px;">
          <div class="col-sm-4">
            <label for="Carriers" class="col-sm-3 col-form-label" style=" white-space: nowrap;">
              Master Account
            </label>
            <div class="col-sm-7">
              <mat-form-field appearance="outline">
                <mat-label>Select Parent Carrier</mat-label>
                <mat-select [(ngModel)]="selectedParentCarrier" #Name="ngModel" name="MultiCarrier">
                  <mat-option [value]="null">None</mat-option>
                  <mat-option *ngFor="let carrier of parentCarriers" [value]="carrier.value">
                    {{carrier.label}}
                  </mat-option>
                </mat-select>              
              </mat-form-field>
            </div>
          </div>
          <div class="col-sm-4">
            <label for="Carriers" class="col-sm-3 col-form-label" style=" white-space: nowrap;">
              Carrier
            </label>
              <div class="col-sm-7"  *ngIf="!selectedParentCarrier">
                <mat-form-field appearance="outline">
                  <mat-label>Select carrier</mat-label>
                  <mat-select [(ngModel)]="selectedCarrier" #Name="ngModel" (selectionChange)="getRateFiles($event)" name="Carriers">
                    <mat-option *ngFor="let carrier of carriers" [value]="carrier.value">
                      {{carrier.label}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
                <div *ngIf="Name.invalid && (Name.dirty || Name.touched)" class="text-danger small">
        <div *ngIf="Name.errors.required">
          Carrier is required.
        </div>
        <div *ngIf="Name.errors.maxlength">
          Carrier must be less than 50 characters long.
        </div>
      </div>
              </div>

              <div class="col-sm-7"  *ngIf="selectedParentCarrier">
                <mat-form-field appearance="outline">
                  <mat-label>Select carrier</mat-label>
                  <mat-select [(ngModel)]="selectedCarrier" #Name="ngModel"  name="Carriers">
                    <mat-option *ngFor="let carrier of childCarriers" [value]="carrier.value">
                      {{carrier.label}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
                <div *ngIf="Name.invalid && (Name.dirty || Name.touched)" class="text-danger small">
                <div *ngIf="Name.errors.required">
                  Carrier is required.
                </div>
                <div *ngIf="Name.errors.maxlength">
                  Carrier must be less than 50 characters long.
                </div>
              </div>
              </div>
          </div>
          <div class="col-sm-4">
            <label for="RateFile" class="col-sm-3 col-form-label" style=" white-space: nowrap;">
              Rate File
            </label>
            <div class="col-sm-9">
              <mat-form-field appearance="outline">
                <mat-label>Select ratefile</mat-label>
                <mat-select [(ngModel)]="selectedRateFile" (selectionChange)="setRateFile($event)" name="RateFile">
                  <mat-option *ngFor="let rate of rateFile" [value]="rate.label">
                    {{rate.label}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <div *ngIf="(rateFile.dirty && rateFile.touched)" class="text-danger small">
                <div *ngIf="rateFile.errors.required">
                  RateFile is required.
                </div>
                <div *ngIf="rateFile.errors.maxlength">
                  RateFile must be less than 50 characters long.
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
      <div class="col-sm-4" style="display: flex;">-->
        <!-- <button type="button" (click)="mapCarrierRateFile(selectedRateFile)" class="btn btn-sm btn-outline-secondary mx-1"> Add </button> -->
        <!-- <button (click)="showNewMap()" type="button" class="btn btn-sm btn-outline-success"><i class="fa fa-plus" aria-hidden="true"></i> Add new </button> -->
        <!--<div>
          <button type="button" *ngIf="mode==formModes.New" (click)="mapCarrierRateFile(selectedParentCarrier,selectedCarrier, selectedRateFile, rateFile)" class="btn btn-sm btn-success mx-1"><i class="fa fa-plus" aria-hidden="true"></i> Save </button>
          <button type="submit" *ngIf="mode==formModes.Edit" (click)="updateMappingCarrierRateFile(selectedParentCarrier,selectedCarrier, rateFile)" class="btn btn-sm mx-1" style="color: white; background-color: #2f72ab;"><i class="fa fa-floppy-o" aria-hidden="true"></i> Update </button>
          <button type="button" class="btn btn-sm mx-1" style="color: white; background-color: #2f72ab;" (click)="clearFields(CarrierForm)"><i class="fa fa-ban" aria-hidden="true"></i> Cancel </button>

        </div>

      </div>
    </div>

    <div class="row" style="position: relative; top: -50px; ">
      <div class="col">
        <div class="mat-elevation-z8">
          <table mat-table [dataSource]="ClientPopupdataSource">

            <ng-container matColumnDef="Carrier">
              <th mat-header-cell *matHeaderCellDef mat-sort-header style=" text-align: center;"> Carrier </th>
              <td mat-cell *matCellDef="let row" style=" text-align: center;">{{ row.carrier?.isMultiCarrier ? row.childCarrier : row.carrier?.name }}  </td>
            </ng-container>

            <ng-container matColumnDef="RateFile">
              <th mat-header-cell *matHeaderCellDef mat-sort-header style=" text-align: center;"> RateFile </th>
              <td mat-cell *matCellDef="let row" style=" text-align: center;"> {{ row.carrierRateFile?.label }} </td>
            </ng-container>

            <ng-container matColumnDef="Actions">
              <th mat-header-cell *matHeaderCellDef mat-sort-header style=" text-align: center;">Actions </th>
              <td mat-cell *matCellDef="let row" style=" text-align: center;">
                <button (click)="showEditMapping(row)" class="btn btn-sm btn-outline-primary"><i class="fa fa-pencil" aria-hidden="true"></i></button>
                <button (click)="deleteMappedCarrierRateFile(row)" class="btn btn-sm btn-outline-danger"><i class="fa fa-times" aria-hidden="true"></i></button>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="CarrierColums"></tr>
            <tr mat-row *matRowDef="let row; columns: CarrierColums;"></tr>

          </table>
          <span style="position: relative; left: 4%; top: 37px; font-size: 13px;">There are {{this.clientsCarrierRateFileData?.length}} records</span>
          <mat-paginator [length]="this.clientsCarrierRateFileData?.length" [pageSizeOptions]="[5,10,50,100]" aria-label="Select page of users"></mat-paginator>
        </div>
      </div>

    </div>-->
    <!--<mat-dialog-actions align="end">
        <button mat-button matDialogClose="no">Cancel</button>
    </mat-dialog-actions>-->
  <!--</div>
</ng-template>-->


